import { render, staticRenderFns } from "./CompTextImgText.vue?vue&type=template&id=512bae93"
import script from "./CompTextImgText.vue?vue&type=script&lang=js"
export * from "./CompTextImgText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports